import React from "react";
import _ from "lodash";
import { Switch, Route, Redirect } from "react-router-dom";

import SnapshotViewer from "./components/snapshot/SnapshotViewer";
import YieldSetSnapshotViewer from "./components/snapshot/YieldSetSnapshotViewer";
import ObserverViewer from "./components/observer/ObserverViewer";
import UnitInsightViewer from "./components/unit-insight/UnitInsightViewer";
import ControlCenterViewer from "./components/control-center/ControlCenterViewer";
import BizViewer from "./components/biz/BizViewer";
import ReportingStatusViewer from "./components/healthcheck/ReportingStatusViewer";
import GptRequestsComparison from "./components/tools/GptRequestsComparison";
import HomeDashboardViewer from "./components/playground/HomeDashboardViewer";
import BatchUpdateAPConfigs from "./components/tools/BatchUpdateAPConfigs";
import YbConsoleOpsLogViewer from "./components/console-ops-log/YbConsoleOpsLogViewer";
import OpsManagementViewer from "./components/ops-mgmt/OpsManagementViewer";
import IntowowBusinessViewer from "./components/intowow-business/I2wBusinessViewer";
import AnatomyDebugViewer from "./components/observer/AnatomyDebugViewer";
import SegmentResearchViewer from "./components/segment-research/SegmentResearchViewer";
import VseViewer from "./components/vse/VseViewer";
import VaultViewer from "./components/vault/VaultViewer";
import UsersViewer from "./components/vault/VaultUsersViewer";
import NetworkCstReportViewer from "components/cst/NetworkCstReportViewer";
import AnatomyCSTViewer from "components/anatomy-cst/AnatomyCSTViewer";
import DiagnoserViewer from "components/diagnoser/DiagnoserViewer";
import UnitsSearchViewer from "components/network/units/UnitsSearchViewer";
import DxDyTrendsViewer from "components/tools/DxDyTrendsViewer";
import PricingRulesViewer from "components/network/pricing-rules/PricingRulesViewer";
import AppConfiguratorViewer from "components/app-configurator/AppConfiguratorViewer";
import InventoryRevenueAnalysisDashboard from "components/inventory-rev/InventoryRevenueAnalysisDashboard";
import IntegrationVerificationViewer from "components/integration-verification/IntegrationVerificationViewer";
import CompetitorsSummaryViewer from "components/competitors-summary/CompetitorsSummaryViewer";
import OnboardInventoryView from "components/onboard-inventory/OnboardInventoryView";
import CrossCheckView from "components/cross-check/CrossCheckView";
import DemandPortfolioView from "components/demand-portfolio/DemandPortfolioView";

import AnatomyCSTProvider from "components/anatomy-cst/context/AnatomyCSTProvider";

import { PATHS } from "helpers/Routes";

function MainRouter() {
  return (
    <>
      <div className="relative h-screen">
        <Switch>
          <Route
            path={PATHS.ybConsoleOpsLog}
            component={YbConsoleOpsLogViewer}
          ></Route>

          <Route
            path={PATHS.ybConsoleHomeDashboard}
            component={HomeDashboardViewer}
          ></Route>

          <Route
            path={PATHS.ybConsoleHomeDashboardReseller}
            component={HomeDashboardViewer}
          ></Route>

          {/* TOOLS */}
          <Route
            path={PATHS.batchUpdate}
            component={BatchUpdateAPConfigs}
          ></Route>

          <Route
            path={PATHS.gptRequestsComparison}
            component={GptRequestsComparison}
          ></Route>

          <Route path={PATHS.dxDyTrends} component={DxDyTrendsViewer}></Route>

          <Route
            path={PATHS.controlCenter}
            component={ControlCenterViewer}
          ></Route>

          <Route
            path={PATHS.segmentResearch}
            component={SegmentResearchViewer}
          ></Route>

          <Route
            path={PATHS.opsManagement}
            component={OpsManagementViewer}
          ></Route>

          <Route
            path={PATHS.reportingStatus}
            component={ReportingStatusViewer}
          ></Route>

          <Route path={PATHS.bizOverview} component={BizViewer}></Route>
          <Route path={PATHS.bizNetwork} component={BizViewer}></Route>

          <Route path={PATHS.vseBase} component={VseViewer}></Route>
          <Route path={PATHS.diagnoserBase} component={DiagnoserViewer}></Route>

          <Route path={PATHS.vaultBase} component={VaultViewer}></Route>
          <Route path={PATHS.usersBase} component={UsersViewer}></Route>

          <Route
            path={PATHS.intowowBusiness}
            component={IntowowBusinessViewer}
          ></Route>

          <Route
            exact
            path={PATHS.unitInsight}
            component={UnitInsightViewer}
          ></Route>

          <Route
            exact
            path={PATHS.cstReport}
            component={NetworkCstReportViewer}
          ></Route>

          <Route
            exact
            path={PATHS.yieldSetSnapshot}
            component={YieldSetSnapshotViewer}
          ></Route>

          <Route exact path={PATHS.snapshot} component={SnapshotViewer}></Route>

          <Route
            exact
            path={PATHS.unitsSearch}
            component={UnitsSearchViewer}
          ></Route>

          <Route
            path={PATHS.pricingRules}
            component={PricingRulesViewer}
          ></Route>

          <Route
            path={PATHS.anatomyCST}
            render={(props) => {
              const unitId = _.get(props, "match.params.unitId");
              return (
                <AnatomyCSTProvider>
                  <AnatomyCSTViewer
                    key={unitId}
                    unitId={unitId}
                  ></AnatomyCSTViewer>
                </AnatomyCSTProvider>
              );
            }}
          ></Route>

          <Route
            path={PATHS.anatomyDebug}
            render={(props) => {
              const expId = _.get(props, "match.params.expId");
              return (
                <AnatomyDebugViewer
                  key={expId}
                  expId={expId}
                ></AnatomyDebugViewer>
              );
            }}
          ></Route>

          <Route
            path={PATHS.observer}
            render={(props) => {
              const unitId = _.get(props, "match.params.unitId");
              return (
                <ObserverViewer key={unitId} unitId={unitId}></ObserverViewer>
              );
            }}
          ></Route>

          <Route
            path={PATHS.anatomy}
            render={(props) => {
              const unitId = _.get(props, "match.params.unitId");
              return (
                <ObserverViewer key={unitId} unitId={unitId}></ObserverViewer>
              );
            }}
          ></Route>

          <Route
            exact
            path="/"
            render={() => <Redirect to={PATHS.snapshotLatest}></Redirect>}
          ></Route>

          <Route
            exact
            path={PATHS.appConfigurator}
            component={AppConfiguratorViewer}
          ></Route>

          <Route
            exact
            path={PATHS.inventoryRev}
            component={InventoryRevenueAnalysisDashboard}
          ></Route>

          <Route
            exact
            path={PATHS.integrationVerify}
            component={IntegrationVerificationViewer}
          ></Route>

          <Route
            exact
            path={PATHS.competitorSummary}
            component={CompetitorsSummaryViewer}
          ></Route>

          <Route
            exact
            path={PATHS.onboardInventory}
            component={OnboardInventoryView}
          ></Route>

          <Route
            exact
            path={PATHS.crossCheckSheet}
            component={CrossCheckView}
          ></Route>

          <Route
            exact
            path={PATHS.demandPortfolio}
            component={DemandPortfolioView}
          ></Route>
        </Switch>
      </div>
    </>
  );
}

export default MainRouter;
